
import React from 'react';
import { Helmet } from 'react-helmet-async';

interface TourData {
  name: string;
  description: string;
  image: string;
  url: string;
  price: string;
  location: string;
  duration?: string;
  startLocation?: string;
  endLocation?: string;
  highlights?: string[];
}

interface TourStructuredDataProps {
  tour: TourData;
}

const TourStructuredData: React.FC<TourStructuredDataProps> = ({ tour }) => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "TouristTrip",
    "name": tour.name,
    "description": tour.description,
    "image": `https://catsabouttowntours.com${tour.image}`,
    "url": tour.url,
    "duration": tour.duration || "PT2H",
    "touristType": ["Cat Lovers", "History Enthusiasts", "NYC Tourists"],
    "offers": {
      "@type": "Offer",
      "price": tour.price,
      "priceCurrency": "USD",
      "availability": "https://schema.org/InStock",
      "validFrom": new Date().toISOString(),
      "seller": {
        "@type": "Organization",
        "name": "Cats About Town Tours",
        "url": "https://catsabouttowntours.com"
      }
    },
    "location": {
      "@type": "Place",
      "name": tour.location,
      "address": {
        "@type": "PostalAddress",
        "addressLocality": tour.location.includes("Brooklyn") ? "Brooklyn" : "New York",
        "addressRegion": "NY",
        "addressCountry": "US"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": tour.location.includes("Brooklyn") ? "40.6962" : "40.7589",
        "longitude": tour.location.includes("Brooklyn") ? "-73.9961" : "-74.0014"
      }
    },
    "provider": {
      "@type": "Organization",
      "name": "Cats About Town Tours",
      "url": "https://catsabouttowntours.com",
      "logo": "https://catsabouttowntours.com/lovable-uploads/a7814c71-1569-43b8-8a9c-e24f811be427.png",
      "telephone": "+1-555-0123",
      "email": "catsabouttowntour@gmail.com"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "bestRating": "5",
      "worstRating": "1",
      "ratingCount": "87"
    },
    "review": [
      {
        "@type": "Review",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5"
        },
        "author": {
          "@type": "Person",
          "name": "Sarah from Chicago"
        },
        "reviewBody": "I never knew cats played such a big role in NYC history! Peggy's passion was infectious, and I learned so many fascinating stories."
      }
    ]
  };

  // Add highlights if provided
  if (tour.highlights && tour.highlights.length > 0) {
    structuredData["mainEntityOfPage"] = {
      "@type": "WebPage",
      "description": `Tour highlights include: ${tour.highlights.join(", ")}`
    };
  }

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default TourStructuredData;
